import styled from 'styled-components'

const Body = styled.div`
  padding-top: 20px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;

  ul, ol {
    margin: 0px 0px 24px;
    padding: 0px 0px 0px 16px;
  }

  a {
    color: black;
    text-decoration: underline;
  }

  img {
    margin-top: 0;
    margin-bottom: 0;
    height: auto;
    max-width: 100%;
  }

  h* {
    margin: 0;
  }

  h1 {
    font-size: 22px;
    line-height: 29px;
  }

  h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 590;
  }

  h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 590;
  }

  h4 {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }

  h5 {
    font-size: 16px;
    font-weight: 590;
    line-height: 24px;
  }

  h6 {
    font-size: 13px;
    margin: 1em 0 .5em;
    line-height: 1.24;
  }
`

export default Body